import React from "react";

const Title = ({ title, className }) => {
  return (
    <div className="relative ml-2 ">
      <div className={`text-start mb-3 mr-3 ${className} text-xl font-bold`}>
        {title}
      </div>
      <span className="w-2 h-2 rounded-full bg-Green absolute  top-1/2 -translate-y-1/2 right-0"></span>
    </div>
  );
};

export default Title;
